// extracted by mini-css-extract-plugin
export default {"dialog":"dialog--F8QFO","header":"header--ukLi7","body":"body--sn3eq","title":"title--seHLN","closeButton":"closeButton--Z1ddn"};